import { Component, namespace, Vue } from 'nuxt-property-decorator';
import { namespace as wishlistStore, actionType } from '../store/modules/wishlist-store';
import {IWishlistItem, IWishlistParams} from '../entities/wishlist-item-entity';

const WishlistStore = namespace(wishlistStore);

@Component({
	async fetch(this: WishlistMixin): Promise<void> {
		await this.getWishlist();
	},
})
export default class WishlistMixin extends Vue {
	@WishlistStore.Action(actionType.GET_WISHLIST) actionGetWishlist!: (params: IWishlistParams) => Promise<IWishlistItem[]>;
	@WishlistStore.Action(actionType.CLEAR_WISHLIST) clearWishlist!: () => Promise<void>;
	@WishlistStore.Action(actionType.REMOVE_ITEM_FROM_WISHLIST) removeItemFromWishlist!: (
		id: number,
	) => Promise<boolean>;

	@WishlistStore.Getter items!: IWishlistItem[];
	@WishlistStore.Getter wishlistCount!: number;

	get extensions(): string[] {
		return ['short_characteristics'];
	}

	async getWishlist () {
		const requestParams: IWishlistParams = {
			extensions: this.extensions || []
		};

		await this.actionGetWishlist(requestParams)
	}
}
